module.exports = __webpack_public_path__ + "img/appCode.png";